export default __webpack_public_path__ + "static/media/d5.f35b3357.png";